const productTemplateAction = {
    BACKUP : 'backup',

    DISCARD : 'discard',

    NEW_PRODUCT_TEMPLATE : 'new product template',

    SAVE : 'save'

};

angular.module('gw-um-j2js')
    .constant('productTemplateAction', productTemplateAction);